module.exports = __webpack_public_path__ + "static/media/2019_conf_Product_Culture_Eats_Execution_Culture.21136f74.png";